import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DataService } from '../data/data.service';
interface MainMenu {
  menu: MenuItem[];
}

interface MenuItem {
  menuValue: string;
  showSubRoute: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class SideBarService {
  private readonly mobileBreakpoint = 991.98;
  private data = inject(DataService);
  private router = inject(Router);

  toggleSideBar: BehaviorSubject<string> = new BehaviorSubject<string>(
    localStorage.getItem('isMiniSidebar') || 'false'
  );

  toggleMobileSideBar: BehaviorSubject<string> = new BehaviorSubject<string>(
    localStorage.getItem('isMobileSidebar') || 'false'
  );

  expandSideBar: BehaviorSubject<string> = new BehaviorSubject<string>('false');

  constructor() {
    this.registerRouterListeners();
  }

  switchSideMenuPosition(): void {
    if (localStorage.getItem('isMiniSidebar')) {
      this.toggleSideBar.next('false');
      localStorage.removeItem('isMiniSidebar');
      this.data.sidebar.map((mainMenus: MainMenu) => {
        mainMenus.menu.map((resMenu: MenuItem) => {
          const menuValue = sessionStorage.getItem('menuValue');
          if (menuValue && menuValue === resMenu.menuValue) {
            resMenu.showSubRoute = true;
          }
        });
      });
    } else {
      this.toggleSideBar.next('true');
      localStorage.setItem('isMiniSidebar', 'true');
      this.data.sidebar.map((mainMenus: MainMenu) => {
        mainMenus.menu.map((resMenu: MenuItem) => {
          resMenu.showSubRoute = false;
        });
      });
    }
  }

  switchMobileSideBarPosition(): void {
    if (this.isMobileSidebarOpen()) {
      this.closeMobileSidebar();
    } else {
      this.openMobileSidebar();
    }
  }

  openMobileSidebar(): void {
    this.setMobileSidebarState(true);
  }

  closeMobileSidebar(): void {
    this.setMobileSidebarState(false);
  }

  closeMobileSidebarIfMobileView(): void {
    if (!this.isMobileViewport()) {
      return;
    }
    this.closeMobileSidebar();
  }

  isMobileSidebarOpen(): boolean {
    return this.toggleMobileSideBar.getValue() === 'true';
  }

  private setMobileSidebarState(isOpen: boolean): void {
    const state = isOpen ? 'true' : 'false';
    this.toggleMobileSideBar.next(state);

    if (isOpen) {
      localStorage.setItem('isMobileSidebar', 'true');
    } else {
      localStorage.removeItem('isMobileSidebar');
    }
  }

  private registerRouterListeners(): void {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => this.handleNavigationEnd());
  }

  private handleNavigationEnd(): void {
    if (!this.shouldAutoCloseMobileSidebar()) {
      return;
    }
    this.closeMobileSidebar();
  }

  private shouldAutoCloseMobileSidebar(): boolean {
    return this.isMobileSidebarOpen() && this.isMobileViewport();
  }

  private isMobileViewport(): boolean {
    if (typeof window === 'undefined') {
      return false;
    }

    return window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
  }
}
